<template>
  <div>
    <b-form-select
      @change="showConfirmation(value,$event)"
      :disabled="editClaim"
      :value="value"
      class="my-0"
      id="input-1"
    >
      <option
        v-for="item in adminHubs" :key="item.admin_hub_code"
        :value="item.admin_hub_code"
      >
      {{item.admin_hub_code}} - {{item.name}}
      </option>
      <option value="OTHERS">Others</option>
    </b-form-select>
  </div>
</template>

<script>

export default {
  props: ["value", "editClaim", "adminHubs"],
  data() {
    return {
      unconfirmedValue: "",
      session: this.$session.get("jwt"),
    };
  },
  methods: {
    refresh() {
      this.$store.dispatch("cxCorporateClaim/getCxReport", this.$route.params.id);
    },
    showConfirmation(newValue, e) {
      this.unconfirmedValue = e;
      const oldValue = this.value;
      if (e == "OTHERS") {
        this.$swal({
          title: "Ubah Admin Hub to Others??",
          type: "warning",
          text: 'enter others value',
          input: 'text',
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!",
          onOpen: () => {
            this.$swal.getConfirmButton().setAttribute('disabled', 'disabled');
            const input = this.$swal.getInput();
            input.oninput = () => {
              this.$swal.getConfirmButton().removeAttribute('disabled');
            };
          },
        }).then((result) => {
          console.log(result);
          if (result.value) {
            this.loading = true;
            const adminHubData = {
              adminhub_code: e,
              adminhub_name: result.value
            };
            this.$store
              .dispatch("cxFoodClaim/putCxAdminHub", {
                id: this.$route.params.id,
                adminHubData,
              })
              .then((response) => {
                this.loading = false;
                this.refresh();
                this.$swal({
                  title: "Change!",
                  text: "Admin Hub has been change.",
                  type: "success",
                  showConfirmButton: false,
                  timer: 1000,
                });
                this.value = e;
                console.log(response);
              })
              .catch((error) => {
                this.loading = false;
                this.serverError = error.response;
                this.$swal({
                  type: "error",
                  title: "Something wrong!",
                  text: error.response.data.data || error.message,
                  showConfirmButton: false,
                  timer: 3000,
                });
              });
          } else {
            this.refresh();
            this.value = undefined;
          }
        });
      } else {
        this.$swal({
          title: "Ubah Admin Hub??",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes!"
        }).then((result) => {
          if (result.value) {
            this.loading = true;
            const adminHubData = {
              adminhub_code: e,
            };
            this.$store
              .dispatch("cxCorporateClaim/putCxAdminHub", {
                id: this.$route.params.id,
                adminHubData,
              })
              .then((response) => {
                this.loading = false;
                this.refresh();
                this.$swal({
                  title: "Change!",
                  text: "Admin Hub has been change.",
                  type: "success",
                  showConfirmButton: false,
                  timer: 1000,
                });
                this.value = e;
                console.log(response);
              })
              .catch((error) => {
                this.loading = false;
                this.serverError = error.response;
                this.$swal({
                  type: "error",
                  title: "Something wrong!",
                  text: error.response.data.data || error.message,
                  showConfirmButton: false,
                  timer: 3000,
                });
              });
          } else {
            this.refresh();
            this.value = undefined;
          }
        });
      }
    },
  },
};
</script>
